import { useTranslation } from 'next-i18next';
import { FilterWrapper } from '../filterWrapper/filterWrapper';
import { FilterType, freeFormHubFilterKeys } from '../../types';
import { useFreeFormHubInputValidator } from '../../hooks/inputValidator';
import { useFreeFormHubFilterState } from '../../hooks/useUrlFilterState';
import { getUnitLabelForUnitSystem, PressureCode } from '@icommerce/units';
import type { UnitSystem } from '@igus/kopla-domain';
import { getIcommerceUnitSystemName } from '@hub/bearing-hub/common/useUnitSystem/useUnitSystem';

interface SurfacePressureSectionProps {
  unitSystem: UnitSystem;
}

export const SurfacePressureSection = ({ unitSystem }: SurfacePressureSectionProps) => {
  const { t } = useTranslation(['category/productFilter', 'common']);

  const numberValidator = useFreeFormHubInputValidator(FilterType.NUMBER);
  const [value, setValue] = useFreeFormHubFilterState<FilterType.NUMBER>(
    freeFormHubFilterKeys.MAX_SURFACE_PRESSURE,
    numberValidator
  );

  return (
    <div className="mt-8">
      <FilterWrapper
        type={FilterType.NUMBER}
        props={{
          key: freeFormHubFilterKeys.MAX_SURFACE_PRESSURE,
          id: freeFormHubFilterKeys.MAX_SURFACE_PRESSURE,
          unit: getUnitLabelForUnitSystem(PressureCode.MEGAPASCAL, getIcommerceUnitSystemName(unitSystem)),
          placeholder: t(`FILTERS.PLACEHOLDER.MAX_SURFACE_PRESSURE`, { ns: 'free-form-hub/freeFormHub' }),
          title: t(`FILTERS.PLACEHOLDER.MAX_SURFACE_PRESSURE`, { ns: 'free-form-hub/freeFormHub' }),
          value: value ? String(value) : '',
          onChange: (newVal: string) => {
            setValue(Number(newVal));
          },
          validator: inputValue => Number(inputValue) > 0,
        }}
      />
    </div>
  );
};
